export default {
  'dashboard': {
    'monday': 'Monday',
    'tuesday': 'Tuesday',
    'wednesday': 'Wednesday',
    'thursdday': 'Thursdday',
    'friday': 'Friday',
    'saturday': 'Saturday',
    'sunday': 'Sunday',
    'morning': 'Morning',
    'afternoon': 'Afternoon',
    'night': 'Night',
    'midnight': 'Midnight',
    'now_time': '{nickname} {nowTimeCall} hello，Now time：{nowTime}',
    'now_time_show': '{year}-{month}{day} {hour}:{minute}:{second} {week}',
    'admins': 'Admins',
    'attachments': 'Attachments',
    'extensions': 'Extensions',
    'groups': 'Groups',
    'system_info': 'System Info',
    'version': 'Version',
    'domain_ip': 'Server domain/ip',
    'server_info': 'Server Info',
    'server_env': 'Server Env',
    'php_version': 'PHP Version',
    'mysql_version': 'MySQL Version',
    'max_upload': 'Max Upload',
    'server_time': 'Server Time'
  }
}
